import { Component, EventEmitter, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ClerkCategory, ClerkProduct } from '../../services/clerk-search/clerk-search.service';

export interface ClerkSearchResultsData {
  products: ClerkProduct[];
  categories: ClerkCategory[];
  suggestions: string[];
  totalCount: number;
  maxResultShow: number;
  showNoResults: boolean;
  searchValue: string;
}

@Component({
  selector: 'lib-clerk-global-search-results',
  templateUrl: './clerk-global-search-results.component.html',
  styleUrls: ['./clerk-global-search-results.component.scss'],
  standalone: false
})
export class ClerkGlobalSearchResultsComponent implements OnChanges, OnDestroy {
  @Input() renderData!: Subject<ClerkSearchResultsData>;

  closeResultsEmitter = new EventEmitter<void>();
  navigateToSearchEmitter = new EventEmitter<void>();
  navigateToSuggestionEmitter = new EventEmitter<string>();
  productClickEmitter = new EventEmitter<string | number>();

  products: ClerkProduct[] = [];
  categories: ClerkCategory[] = [];
  suggestions: string[] = [];
  totalCount = 0;
  maxResultShow = 5;
  showNoResults = false;
  searchValue = '';

  private readonly unsubscribe = new Subject<void>();
  private dataUnsubscribe = new Subject<void>();

  get hasSidebar(): boolean {
    return this.categories.length > 0 || this.suggestions.length > 0;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['renderData']?.currentValue) {
      this.dataUnsubscribe.next();
      this.renderData.pipe(takeUntil(this.dataUnsubscribe), takeUntil(this.unsubscribe)).subscribe(data => {
        this.products = data.products;
        this.categories = data.categories;
        this.suggestions = data.suggestions;
        this.totalCount = data.totalCount;
        this.maxResultShow = data.maxResultShow;
        this.showNoResults = data.showNoResults;
        this.searchValue = data.searchValue;
      });
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
